export default {"src":"/_next/static/media/discord.25d1e60c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};